import React, {Component} from 'react';
import cookie from '../helper/cookie.js'

export default class Side extends Component{

constructor(props)
{
  super(props);

  if (this.props.source == "settings") {
    this.state={hm:false,allp:false,cust1:false,agnt:false,sett:true};
  }
  else if (this.props.source == "customers") {
    this.state={hm:false,allp:false,cust1:true,agnt:false,sett:false};
  }
  else if (this.props.source == "agents") {
    this.state={hm:false,allp:false,cust1:false,agnt:true,sett:false};
  }
  else if (this.props.source == "projects") {
    this.state={hm:false,allp:true,cust1:false,agnt:false,sett:false};
  }
  else {
    this.state={hm:true,allp:false,cust1:false,agnt:false,sett:false};
  }
  
  this.hClick=this.hClick.bind(this);
  this.uClick=this.uClick.bind(this);
  this.agnClick=this.agnClick.bind(this);
  this.alpClick=this.alpClick.bind(this);
  this.setClick=this.setClick.bind(this);
}
hClick()
{
    if(!this.state.hm)
    {
      this.setState({hm:true,allp:false,cust1:false,cust2:false,agnt:false,sett:false});
      window.location.href = "/#/admin/" + cookie.get('userId');
    }
}
uClick()
{
  if(!this.state.cust1)
  {
    this.setState({hm:false,allp:false,cust1:true,cust2:true,agnt:false,sett:false});
    window.location.href = "/#/allcustomers/" + cookie.get('userId');
  }
}
agnClick()
{
  if(!this.state.agnt)
  {
    this.setState({hm:false,allp:false,cust1:false,cust2:false,agnt:true,sett:false});
    window.location.href = "/#/allagents/" + cookie.get('userId');
  }
}
alpClick()
{
  if(!this.state.allp)
  {
    this.setState({hm:false,allp:true,cust1:false,cust2:false,agnt:false,sett:false});
    window.location.href = "/#/allprojects/" + cookie.get('userId'); 
  }
}

setClick()
{
  if(!this.state.sett)
  {
    this.setState({hm:false,allp:false,cust1:false,cust2:false,agnt:false,sett:true});
    window.location.href = "/#/agentSettings/" + cookie.get('userId');
  }
}

  render()
  {
    var st={
          col_1:{
              cursor:"pointer",
              marginLeft:5,
              color:"#000000",
          },
          col_2:{
              cursor:"pointer",
              marginLeft:3,
              color:"#000000",
          },
          col_3:{
              marginLeft:5,
              marginBottom:-40,
              cursor:"pointer",
              color:"#000000",
          },
          col_5:{
              marginLeft:5,
              color:"#000000",
              cursor:"pointer",
          },
          col_6:{
              marginLeft:3,
              cursor:"pointer",
              color:"#000000",
          },

          let_1:{
            cursor:"pointer",
              color:"#000000",
          },

          let_2:{
            cursor:"pointer",
              paddingLeft:10,
              color:"#000000",
          },
          let_2_1:{
            cursor:"pointer",
            marginLeft:-8,
            color:"#000000",
          },

          let_3:{
            cursor:"pointer",
            color:"#000000",
          },

          let_4:{
            marginLeft:-14,
            cursor:"pointer",
            color:"#000000",
          },

          let_5:{
            cursor:"pointer",
            marginLeft:-5,
            color:"#000000",
          },

          let_6:{
            cursor:"pointer",
              marginLeft:-12,
              color:"#000000",
          },

    }

    if(this.state.hm)
    {
      st.col_1.color="#1a84eb";
      st.let_1.color="#1a84eb";
    }
    if(this.state.allp)
    {
      st.col_2.color="#1a84eb";
      st.let_2.color="#1a84eb";
      st.let_2_1.color="#1a84eb";

    }
    if(this.state.cust1)
    {
      st.col_3.color="#1a84eb";
      st.let_4.color="#1a84eb";
      st.let_3.color="#1a84eb";
    }
    if(this.state.agnt)
    {
      st.col_5.color="#1a84eb";
      st.let_5.color="#1a84eb";
    }
    if(this.state.sett)
    {
      st.let_6.color="#1a84eb";
      st.col_6.color="#1a84eb";
    }

    return(
        <div>
            <ul className="list-unstyled">

              <li type="checkbox" onClick={this.hClick} style={{cursor:"pointer"}} >
                <h3 id ="home" className="glyphicon glyphicon-home" style={st.col_1} ></h3>
                <p id ="homeName" className="" style={st.let_1}><small>Home</small></p>

              </li>
              <li type="checkbox" onClick={this.alpClick} style={{cursor:"pointer"}}>
                <h3 id ="allproject" className="glyphicon glyphicon-list-alt" style={st.col_2} ></h3>
                <div style={st.let_2} ><small>All</small></div>
                <div style={st.let_2_1}  ><small>Projects</small></div>
              </li>
              <li>
                <h3 id ="customer1" className=" glyphicon glyphicon-user" style={st.col_3} type="checkbox" onClick={this.uClick}></h3>
                <p id ="homeName" className="text-left" style={st.let_4} type="checkbox" onClick={this.uClick} ><small>Customers</small></p>
              </li>
              <li>
                <h3 id ="agents" className="glyphicon glyphicon-user" style={st.col_5} type="checkbox" onClick={this.agnClick}></h3>
                <p id ="homeName" className="text-left" style={st.let_5} type="checkbox" onClick={this.agnClick} ><small>Agents</small></p>
              </li>
              <li>
                <h2 id ="settings" className="glyphicon glyphicon-cog" style={st.col_6} type="checkbox" onClick={this.setClick}></h2>
                <p id ="homeName" className="text-left" style={st.let_6} type="checkbox" onClick={this.setClick} >Settings</p>
              </li>
            </ul>
        </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Sidebar.js
 **/